import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/kabox-frontend/kabox-frontend/app/[locale]/blog/[slug]/content.jsx");
